import { useEffectOnce, useLocalStorage, useSearchParam } from 'react-use';
import { AppThemeName, appThemes, isAppThemeName } from '../styles/appTheme';
import { useMemo } from 'react';
import { isProduction } from '../utils/processUtils';

const ENV_APP_THEME_NAME = process.env.REACT_APP_THEME || AppThemeName.DEFAULT;
if (!isAppThemeName(ENV_APP_THEME_NAME)) {
  throw new Error(`Invalid app theme name: ${ENV_APP_THEME_NAME}`);
}

const APP_THEME_LOCAL_STORAGE_KEY = 'appTheme';
const APP_THEME_SEARCH_PARAM_NAME = 'THEME';
const SEARCH_PARAM_RESET_VALUE = 'RESET';

export const useAppTheme = !isProduction
  ? () => {
      const [
        selectedAppThemeName,
        setSelectedAppThemeName,
        clearSelectedAppThemeName,
      ] = useLocalStorage<AppThemeName>(APP_THEME_LOCAL_STORAGE_KEY);
      const uriAppThemeName = useSearchParam(APP_THEME_SEARCH_PARAM_NAME);

      useEffectOnce(() => {
        if (!uriAppThemeName) {
          return;
        }
        if (uriAppThemeName === SEARCH_PARAM_RESET_VALUE) {
          // App theme was reset using the search param
          clearSelectedAppThemeName();
        } else if (isAppThemeName(uriAppThemeName)) {
          // App theme was set using the search param
          setSelectedAppThemeName(uriAppThemeName);
        }
      });

      return useMemo(() => {
        // If we have a selected app theme, use it
        // Otherwise, use the app theme from the environment variable
        return appThemes[
          isAppThemeName(selectedAppThemeName)
            ? selectedAppThemeName
            : ENV_APP_THEME_NAME
        ];
      }, [selectedAppThemeName]);
    }
  : () => appThemes[ENV_APP_THEME_NAME];
